import { createContext, useContext } from 'react';

export interface ColorPickerValues {
  colorString?: string;
  onChange: (colorString: string) => void;
}

export const ColorPickerContext = createContext<ColorPickerValues>({
  colorString: '',
  onChange: () => {},
});

export const useColorPickerContext = () => {
  const context = useContext(ColorPickerContext);
  if (context === undefined) {
    throw new Error(
      'useColorPickerContext must be used within a ColorPickerContext.Provider'
    );
  }
  return context;
};
